import { ChangesStatus } from '@editor2/types/changesStatus';
import { type FC } from 'react';

interface Props {
	currentIds: string[];
	initialIds: string[];
	changesEntity: any;
	title: string;
}

const ChildrenChanges: FC<Props> = (props) => {
	const { currentIds, initialIds, changesEntity, title } = props;

	const addedItems = currentIds.filter((id) =>
		changesEntity[id]?.includes(ChangesStatus.New)
	).length;
	const deletedItems = initialIds.filter((id) =>
		changesEntity[id]?.includes(ChangesStatus.Deleted)
	).length;

	const addPluralForm = (items: number) => {
		return items > 1 ? 's' : '';
	};

	return (
		<div>
			<div className="changeTitle">Reordered {title}s</div>
			{!!addedItems && (
				<div className="changeTitle">{`${addedItems} new ${title}${addPluralForm(
					addedItems
				)}`}</div>
			)}
			{!!deletedItems && (
				<div className="changeTitle">{`${deletedItems} deleted ${title}${addPluralForm(
					deletedItems
				)}`}</div>
			)}
		</div>
	);
};

export default ChildrenChanges;
